import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { useStore } from "../../../stores/use_global_state";
import { AdvicesBlock, EntryBlock, FeaturesBlock, TutorialBlock, VideoUpload, BoldMenu, UploadProgress, MainBlob, TryOurTools, UploadYourFile, FaqComponent, MemoizedReviews } from "./dependency";

function UploadFileLayout(props) {
	const { state } = useStore();
	const { trim_start, trim_duration, uploadFile, uploadedProgress, setUploadedProgress, delFile, dictionary, style, isTrim, pageType = "", openAuthModal } = props;

	const [progress, setProgress] = useState(0);
	const router = useRouter();

	const backBtnHandler = () => {
		if (state?.video) {
			delFile();
		} else {
			router.push("/");
		}
	};

	useEffect(
		() => {
			if (uploadedProgress !== null && 100 >= uploadedProgress) setProgress(Math.floor(uploadedProgress * 0.8));
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[uploadedProgress]
	);

	const tutorialData = [
		{
			title: dictionary["upload"] || "Upload",
			description: dictionary["howto_step1"] || "Open our background remover and upload your file (supported formates: .mp4, .mov, .mkv, .webm, maximum resolution is 1920x1080).",
		},
		{ title: dictionary["choose_new_background"] || "Choose new background", description: dictionary["howto_step2"] || "Select photo/video/color background from our library or upload your own." },
		{ title: dictionary["add_style"] || "Add style", description: dictionary["howto_step3"] || "Add funny stickers, text or music to make your project incredible." },
		{ title: dictionary["download"] || "Download", description: dictionary["howto_step4"] || "Click the download button and save the result to your device." },
	];

	const textData = { title: dictionary["page_removebg_header_howto"] || "How to remove the background from video?", videoUrl: "/video/how_to.mp4", posterUrl: "/video/how_to_preview.webp" };

	useEffect(
		() => {
			if (state.task?.output_type === "preview") {
				const notionalInterest = () => setProgress(progress + 1);

				if (progress < 95) notionalInterest();

				if (state.task?.status === "done") {
					setProgress(100);
					setUploadedProgress(null);
				}
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[state.task]
	);

	return (
		<>
			{state?.video ? (
				<>
					<BoldMenu dictionary={dictionary} btn={state?.video ? ["back"] : []} onBackBtn={backBtnHandler} pageTitle={pageType} />
					<div className={style.wrapper}>
						<VideoUpload {...{ progress, trim_duration, trim_start, delFile, style, isTrim, dictionary }} />
					</div>
					{state.video && <UploadProgress {...{ dictionary, progress }} isAdaptive={false} />}
				</>
			) : (
				<>
					<EntryBlock {...{ dictionary, uploadFile, openAuthModal }} />
					<FeaturesBlock dictionary={dictionary} />
					<TutorialBlock tutorialData={tutorialData} textData={textData} />
					<AdvicesBlock dictionary={dictionary} />
					<MemoizedReviews dictionary={dictionary} colorOn={true} type={"bgrem"} />
					<UploadYourFile dictionary={dictionary} uploadFile={uploadFile} />
					<FaqComponent dictionary={dictionary} pageName={"page_bgrem"} />
					<TryOurTools t={dictionary} />
				</>
			)}
			{state.video && <MainBlob isBlur={true} isBack={true} />}
		</>
	);
}

export default UploadFileLayout;
